import { BaseCalculationService } from "./BaseCalculationService";
import { PortfolioItemModel } from "../../../features/portfolio-info/types/PortfolioItemModel";
import { blackScholesModelCalculationService } from "../BlackScholesModelCalculationService";
import dayjs from "dayjs";

export class DeltaCalculationService extends BaseCalculationService {
    protected calculateForFutures(item: PortfolioItemModel): number {
        return item.size;
    }

    protected calculateForOption(item: PortfolioItemModel,
        underlyingPrice: number, timeToExpirationInShareOfYear: number
    ): number {
        const isExpired = item.expireAt !== null
            ? blackScholesModelCalculationService.getTimeToExpirationInShareOfYear(item.expireAt, dayjs().toDate()) < 0
            : true;

        if (isExpired) {
            // todo: calc option price after expiration
            return 0;
        }
        
        if (item.markImpliedVolatility === null) {
            throw new Error("ImpliedVolatility cannot be null!");
        }

        if (item.strike === null) {
            throw new Error("Portfolio item property 'strike' is null.")
        }
        
        return blackScholesModelCalculationService.getDelta(
            item.type, underlyingPrice, item.strike, timeToExpirationInShareOfYear, item.markImpliedVolatility);
    }
}